import { render, staticRenderFns } from "./LinuxDelayAccounting.vue?vue&type=template&id=2a126946&scoped=true"
import script from "./LinuxDelayAccounting.vue?vue&type=script&lang=js"
export * from "./LinuxDelayAccounting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a126946",
  null
  
)

export default component.exports